<template>
	<div>
		<div
			class="user-preview-card__wrapper d-flex align-center mb-2"
			v-bind:style="{ paddingTop: userFlag ? '30px' : '12px' }"
		>
			<SponsorBadge
				v-if="userFlag"
				:text="userFlag.flag_name"
				:top="'0px'"
				:right="'0px'"
				:iconSize="10"
				:iconColor="'#ffffff'"
				:background="userFlag.flag_bg_color"
				:color="userFlag.flag_txt_color"
			/>
			<Avatar :size="52" class="mr-3 post-preview-card__avatar" :avatar="logo" />
			<div class="user-preview-card__info">
				<div v-if="name" class="user-preview-card__title">
					{{ name }}
				</div>
				<div v-if="secondRow" class="user-preview-card__description mt-1">
					{{ secondRow }}
				</div>
				<div v-if="thirdRow" style="margin-top: 2px" class="user-preview-card__description">
					{{ thirdRow }}
				</div>
				<div v-if="location" class="user-preview-card__location d-flex align-center mt-2">
					<Icon type="pin" color="var(--location-color)" :size="16" :pr="4" />
					{{ location }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar'
import ProfileBadge from '@/components/ProfileBadge.vue'
import SponsorBadge from '@/components/SponsorBadge.vue'

Vue.use(VueScrollTo)

export default {
	name: 'AttendCard',

	components: {
		SponsorBadge,
		Avatar,
		ProfileBadge,
	},
	props: {
		user: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		userFlag() {
			const { userFlag: flag } = this.user || {}

			return flag
		},
		logo() {
			const { user_logo: logo } = this.user || {}

			return logo
		},
		name() {
			const { visible_username: name } = this.user || {}

			return name
		},
		location() {
			const { location_profile_row: location } = this.user || {}

			return location
		},
		secondRow() {
			const { second_profile_row: row } = this.user || {}

			return row
		},
		thirdRow() {
			const { third_profile_row: row } = this.user || {}

			return row
		},
	},
}
</script>

<style lang="scss">
.user-preview-card {
	&__wrapper {
		display: flex;
		background: #ffffff;
		border-radius: 8px;
		padding: 12px;
		position: relative;
		border: 1px solid #e2e2e2;
	}

	&__logo {
		width: 25%;
		object-fit: contain;
		margin-right: 12px;
	}

	&__title {
		color: var(--username-category-title);
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
		word-break: break-word;
	}

	&__location {
		display: flex;
		color: var(--location-color);
		font-family: 'Inter', sans-serif;
		font-weight: 500;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
		word-break: break-word;
	}

	&__description {
		color: var(--company-position-large);
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
		word-break: break-word;
	}

	&__user-flag {
		text-align: right;
		position: absolute;
		border-radius: 12px;
		top: 0;
		right: 0;

		span {
			z-index: 0;
			position: relative;
			background: var(--accent-color);
			display: inline-flex;
			padding: 5px 10px 5px 10px;
			border-top-right-radius: 8px;
			color: rgb(255, 255, 255);
			font-size: 12px;
			font-family: 'Inter', sans-serif;
			font-weight: bold;
		}

		// Start
		span {
			span {
				z-index: -1;
				content: '';
				position: absolute;
				left: -17%;
				top: 0;
				height: 100%;
				width: 100%;
				-webkit-transform: skewX(20deg);
				-moz-transform: skewX(20deg);
				-ms-transform: skewX(20deg);
				transform: skewX(20deg);
			}
		}
	}
}

@media screen and (min-width: 1200px) {
	.user-preview-card__wrapper {
		max-width: 100%;
		width: 100%;
	}
}

@media screen and (min-width: 1320px) {
	.user-preview-card__wrapper {
		max-width: 600px;
	}
}
</style>
